module.exports = __webpack_public_path__ + "buy_x.3ba3cd60ad3209060692.jpg";